import { useDispatch, useSelector } from 'react-redux';

import logoImage from '@app/assets/logos/logo-symbol-36h-@2x.jpg';
import trialPlanImage from '@app/assets/trial-plan.jpg';
import {
  getIsAvailableTrialPlan,
  getIsStarting,
  startTrialPlan,
} from '@app/features/subscription/state';

import './TrialStartModal.scss';

function TrialStartModal() {
  const dispatch = useDispatch();
  const isStarting = useSelector(getIsStarting);
  const isAvailableTrialPlan = useSelector(getIsAvailableTrialPlan);
  const handleStartTrialPlan = () => {
    if (!isStarting && isAvailableTrialPlan) {
      dispatch(startTrialPlan());
    }
  };

  return (
    <div className="Container Container--max-sm Container--min-global">
      <div className="Card Card--theme-my-info box-8x align-center">
        <div className="TrialStartModal__title">
          <h1 className="display-inline-block">
            <strong>첫 달을 무료로 이용해보세요!</strong>
          </h1>
          <img alt="logoImage" className="TrialStartModal__logo" src={logoImage} width="36px" />
        </div>
        <div className="align-left">
          <p className="space-4x">
            모두싸인의 모든 서비스를 누릴 수 있는
            <br />
            Trial 요금제를 1달간 무료로 제공합니다.
          </p>
        </div>
        <div className="align-center space-3x">
          <img
            alt="trial-plan-information"
            className="TrialStartModal__trial-plan-image"
            src={trialPlanImage}
          />
        </div>
        <div className="space-3x">
          <button className="Btn Btn--primary Btn--xl" type="button" onClick={handleStartTrialPlan}>
            첫 달 무료 시작하기
          </button>
        </div>
      </div>
    </div>
  );
}

export default TrialStartModal;
